import React, { useEffect } from 'react';
import { X, ExternalLink } from 'lucide-react';

const providers = [
  {
    name: 'Dr. Concepcion Anayas',
    specialty: 'Pediatrics',
    url: 'https://healow.com/apps/provider/concepcion-anayas-3969312',
  },
  {
    name: 'Dr. Marcelo Anayas',
    specialty: 'Internal Medicine',
    url: 'https://healow.com/apps/provider/marcelo-anayas-3909602',
  },
  {
    name: 'Pam Perry, ARNP',
    specialty: 'Pediatrics',
    url: 'https://healow.com/apps/provider/bernavette-perry-3909601',
  },
];

const ScheduleModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      data-testid="schedule-modal-overlay"
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div
        data-testid="schedule-modal"
        className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-auto overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-gradient-to-r from-blue-700 to-blue-800 px-6 py-5 flex items-center justify-between">
          <h2 className="text-xl font-bold text-white">Select Your Provider</h2>
          <button
            onClick={onClose}
            data-testid="schedule-modal-close"
            className="text-white/80 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10"
          >
            <X size={24} />
          </button>
        </div>
        <div className="p-6 space-y-3">
          {providers.map((provider) => (
            <a
              key={provider.name}
              href={provider.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`schedule-provider-${provider.name.split(' ')[1]?.toLowerCase()}`}
              className="flex items-center justify-between w-full px-5 py-4 rounded-xl border border-gray-200 hover:border-blue-400 hover:bg-blue-50 transition-all group"
            >
              <div>
                <p className="font-bold text-gray-900 text-lg group-hover:text-blue-700 transition-colors">{provider.name}</p>
                <p className="text-sm text-gray-500">{provider.specialty}</p>
              </div>
              <ExternalLink size={20} className="text-gray-400 group-hover:text-blue-600 flex-shrink-0 transition-colors" />
            </a>
          ))}
        </div>
        <div className="px-6 pb-5">
          <p className="text-xs text-gray-400 text-center">Opens Healow scheduling in a new tab</p>
        </div>
      </div>
    </div>
  );
};

export default ScheduleModal;
